export const collisionTranslationsEn = {
  name: 'Collision | Collisions',
  helpLink: 'Learn more about collisions',
  hiddenByFilter: 'Hidden by filter | Hidden by filters',
  jumpToCollision: 'Jump to collision | Jump to collisions',
  jumpToResourceCollision: 'Show in resource curve',
  myActivities: 'My activities',
  noCollisionsAffectingYou: 'No collisions that affect you directly',
  otherCollisions: 'Other collisions',
  collisionEventTooltipFiltered: 'Collision hidden by filters | Collisions hidden by filters',
  collisionDetailsTooltipTextOrder: 'Required prep work for {successor} is not completed in time',
  collisionDetailsTooltipTextMilestone: '{predecessor} hinders reaching the milestone {successor}',
  collisionMilestoneNotificationTitle: 'Your milestone is in danger',
  collisionMilestoneNotificationBody:
    'Your milestone got exceeded by a dependent activity or milestone.',
  collisionSidebarSubtext:
    'The schedule assistant keeps an eye on dependencies and notifies you in case of a collision.',
  generalCollisionMessageActivity:
    'Your activity is at risk, as it got exceeded by a dependent activity or milestone. | Your activity is at risk, as it got exceeded by several dependent activities or milestones.',
  generalCollisionMessageMilestone:
    'Your milestone is at risk, as it got exceeded by a dependent activity or milestone. | Your milestone is at risk, as it got exceeded by several dependent activities or milestones.',
  notificationOrderStart: 'The start is at risk because of "{fromName}".',
  notificationOrderFinish: 'The end is at risk because of "{fromName}".',
  notificationEntityMilestone: 'Your milestone is at risk because because of "{fromName}".',
  scheduleAssistantActiveTitle: 'Schedule assistant is active',
  scheduleAssistantActiveText:
    'Fixed milestones are monitored and koppla notifies you immediately if a milestone is in danger.',
  scheduleAssistantAvailableTitle: 'Schedule assistant is available',
  scheduleAssistantAvailableText:
    'As soon as the fixed milestone has incoming dependencies, it will be monitored.',
  scheduleAssistantInactiveTitle: 'Schedule assistant is not active',
  scheduleAssistantInactiveText:
    'This milestone is flexible and moves automatically when rescheduling its dependencies.',
  detailedCollisionMessageDependency: 'Minimum distance ({lag}) violated by {violation}',
};
